/**
 * this import is excluded from client-side build
 * @see package.json:browser
 */

const noopLogger = {
  log: () => {},
  error: () => {},
  info: () => {},
  debug: () => {},
  warn: () => {},
};

const consoleLogger = {
  log: console.log,
  error: console.error,
  info: console.info,
  debug: console.debug,
  warn: console.warn,
};

let instance: any;

if (typeof window !== 'undefined') {
  instance = process.env.NODE_ENV === 'production' ? noopLogger : consoleLogger;
} else {
  const mod = require('@ecg-marktplaats/aurora-node-logging');
  instance = mod?.default ?? mod;
}

export default instance;
